module.exports = __webpack_public_path__ + "static/img/bg_2.6d60e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_2.png
// module id = pMXe
// module chunks = 0